/**
 * OcrScanningIndicator — themed loading state shown while the server OCRs a
 * scanned document. An ID-card illustration with a crimson scan line sweeping
 * across it, matching the crimson/cream card language of the payment-method
 * popup. Colours come from the theme tokens so it tracks light/print contexts.
 * The sweep is CSS-animated (see `.ocr-scan-line` in index.css) and freezes
 * under prefers-reduced-motion.
 */
export function OcrScanningIndicator() {
  return (
    <div className="flex flex-col items-center gap-3 rounded-lg border-2 border-primary/20 bg-primary/5 px-4 py-5 text-center">
      <svg
        viewBox="0 0 200 132"
        role="img"
        aria-label="Membaca dokumen"
        className="h-24 w-auto"
      >
        <defs>
          <linearGradient id="ocr-glow" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="hsl(var(--primary))" stopOpacity="0" />
            <stop offset="1" stopColor="hsl(var(--primary))" stopOpacity="0.22" />
          </linearGradient>
          <clipPath id="ocr-card-clip">
            <rect x="4" y="4" width="192" height="124" rx="12" />
          </clipPath>
        </defs>

        {/* Card body */}
        <rect
          x="4"
          y="4"
          width="192"
          height="124"
          rx="12"
          fill="hsl(var(--card))"
          stroke="hsl(var(--border))"
          strokeWidth="2"
        />

        {/* Photo + head silhouette */}
        <rect x="18" y="24" width="50" height="62" rx="7" fill="hsl(var(--secondary))" />
        <circle cx="43" cy="46" r="12" fill="hsl(var(--muted-foreground))" opacity="0.35" />
        <path d="M25 84 a18 18 0 0 1 36 0 Z" fill="hsl(var(--muted-foreground))" opacity="0.35" />

        {/* Field lines */}
        <rect x="84" y="30" width="96" height="9" rx="4.5" fill="hsl(var(--secondary))" />
        <rect x="84" y="49" width="74" height="9" rx="4.5" fill="hsl(var(--secondary))" />
        <rect x="84" y="68" width="88" height="9" rx="4.5" fill="hsl(var(--secondary))" />
        <rect x="18" y="100" width="140" height="9" rx="4.5" fill="hsl(var(--secondary))" />

        {/* Scan line — clipped to the card so the glow never spills */}
        <g clipPath="url(#ocr-card-clip)">
          <g className="ocr-scan-line">
            <rect x="4" y="-16" width="192" height="16" fill="url(#ocr-glow)" />
            <rect x="4" y="0" width="192" height="3" rx="1.5" fill="hsl(var(--primary))" />
          </g>
        </g>
      </svg>

      <div>
        <p className="font-display font-semibold text-ink-900">Membaca dokumen…</p>
        <p className="mt-0.5 text-xs text-ink-400">Server memproses OCR — mohon tunggu.</p>
      </div>
    </div>
  );
}
